import CustomElementAdd from '../components/CustomElementAdd.vue';
import CustomElementList from '../components/CustomElementList.vue';

export default [
  {
    path: '',
    redirect: 'list',
    role: ['User']
  },
  {
    path: 'list',
    component: CustomElementList,
    meta: {
      title: 'List of custom elements',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: 'list',
          title: 'Custom Element'
        },
        {
          path: 'list',
          title: 'Custom Element List'
        }
      ]
    }
  },
  {
    path: 'add',
    component: CustomElementAdd,
    meta: {
      title: 'Add Custom Element',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: 'list',
          title: 'Custom Element list'
        },
        {
          path: 'add',
          title: 'Add Custom Element'
        }
      ]
    }
  },
];
